import { SHEET_NAME as OTHER_ASSESSMENTS_SHEET } from "./otherAssessmentsSheet";
import { SHEET_NAME as OTHER_VALUE_CHAIN_SHEET } from "./detailsOfOtherValueChainSheet";
import {
  CALC_FILL,
  SUBHEADER_FILL,
  TABLE_HEADER_FILL,
  addMinimumWagesBlock,
  addQuestionRow,
  addSectionHeader,
  addShortAnswerRow,
  addTextAnswerRow,
  addTrainingBlock,
  formatNumber,
  formatPercent,
  getFyLabels,
  mergeRow,
  safeText,
  setCell,
  setPrinciple5ColumnWidths,
  toYesNo,
  toYesNoNa,
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  COL_L,
  COL_M,
  COL_N,
} from "./principle5SheetHelpers";

const PRINCIPLE_TITLE = "Businesses should respect and promote human rights.";

const COMPLAINT_TYPES = [
  ["Sexual Harassment", "sexualHarassemnt1"],
  ["Discrimination at workplace", "discrimination2"],
  ["Child Labour", "childLabor3"],
  ["Forced Labour/Involuntary Labour", "forcedLabor4"],
  ["Wages", "wages5"],
];

const ASSESSMENT_ROWS = [
  ["Child labour", "childLabor"],
  ["Forced/involuntary labour", "forcedLabor"],
  ["Sexual harassment", "sexualHarassment"],
  ["Discrimination at workplace", "discrimination"],
  ["Wages", "wages"],
  ["Others – please specify", "other"],
];

const VALUE_CHAIN_ROWS = [
  ["Sexual harassment", "sexualHarassment"],
  ["Discrimination at workplace", "discrimination"],
  ["Child Labour", "childLabor"],
  ["Forced Labour/Involuntary Labour", "forcedLabor"],
  ["Wages", "wages"],
  ["Others – please specify", "other"],
];

const MEDIAN_ROWS = [
  ["Board of Directors (BoD)", "boardOfDirectors"],
  ["Key Managerial Personnel", "keyManagementPersonnel"],
  ["Employees other than BoD and KMP", "otherEmployees"],
  ["Workers", "workers"],
];

function remarkCell(ws, row, col, remark) {
  const hasText = remark !== null && remark !== undefined && String(remark).trim() !== "";
  setCell(ws, row, col, hasText ? safeText(remark) : "Show Detail", {
    align: hasText ? "left" : "center",
    vertical: "top",
  });
}

function addComplaintsTable(ws, row, complaints, fyCurrent, fyPrevious) {
  mergeRow(ws, row, COL_D, COL_D, "", { fill: TABLE_HEADER_FILL });
  mergeRow(ws, row, COL_E, COL_G, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_H, COL_J, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  row += 1;

  setCell(ws, row, COL_D, "Category", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_E, "Filed during the year", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_F, "Pending resolution at the end of year", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_G, "Remarks", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_H, "Filed during the year", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_I, "Pending resolution at the end of year", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_J, "Remarks", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  row += 1;

  const curr = complaints?.currentFinancialYear1 || {};
  const prev = complaints?.previousFinancialYear1 || {};

  COMPLAINT_TYPES.forEach(([label, key]) => {
    setCell(ws, row, COL_D, label, { align: "left" });
    setCell(ws, row, COL_E, formatNumber(curr?.[key]?.fliedYear), { align: "center" });
    setCell(ws, row, COL_F, formatNumber(curr?.[key]?.pending), { align: "center" });
    remarkCell(ws, row, COL_G, curr?.[key]?.remark);
    setCell(ws, row, COL_H, formatNumber(prev?.[key]?.fliedYear), { align: "center" });
    setCell(ws, row, COL_I, formatNumber(prev?.[key]?.pending), { align: "center" });
    remarkCell(ws, row, COL_J, prev?.[key]?.remark);
    row += 1;
  });

  return row;
}

function addPoshTable(ws, row, posh, fyCurrent, fyPrevious) {
  mergeRow(ws, row, COL_D, COL_D, "", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_E, COL_G, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_H, COL_J, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  row += 1;

  const rows = [
    [
      "Total Complaints reported under Sexual Harassment on of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (POSH)",
      posh?.totalComplaints,
    ],
    [
      "Complaints on POSH as a % of female employees / workers",
      posh?.complaintsFemaleEmployee,
      true,
    ],
    ["Complaints on POSH upheld", posh?.poshUpheld],
  ];

  rows.forEach(([label, data, isPercent]) => {
    setCell(ws, row, COL_D, label, { align: "left", vertical: "top" });
    const curr = isPercent ? formatPercent(data?.currentFinancialYear) : formatNumber(data?.currentFinancialYear);
    const prev = isPercent ? formatPercent(data?.previousFinancialYear) : formatNumber(data?.previousFinancialYear);
    mergeRow(ws, row, COL_E, COL_G, curr, {
      align: "center",
      fill: isPercent ? CALC_FILL : undefined,
    });
    mergeRow(ws, row, COL_H, COL_J, prev, {
      align: "center",
      fill: isPercent ? CALC_FILL : undefined,
    });
    row += 1;
  });

  return row;
}

function addAssessmentTable(ws, row, assessments, otherSheetName) {
  mergeRow(ws, row, COL_D, COL_D, "", { fill: TABLE_HEADER_FILL });
  mergeRow(
    ws,
    row,
    COL_E,
    COL_N,
    "% of your plants and offices that were assessed (by entity or statutory authorities or third parties)",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );
  row += 1;

  ASSESSMENT_ROWS.forEach(([label, key]) => {
    setCell(ws, row, COL_D, label, { align: "left" });
    if (key === "other") {
      mergeRow(ws, row, COL_E, COL_N, "Show Detail", {
        align: "center",
        link: `#'${otherSheetName}'!D3`,
      });
    } else {
      mergeRow(ws, row, COL_E, COL_N, formatPercent(assessments?.[key]?.plantsOffices), { align: "center" });
    }
    row += 1;
  });

  return row;
}

function addValueChainTable(ws, row, leadership, otherSheetName) {
  mergeRow(ws, row, COL_D, COL_D, "", { fill: TABLE_HEADER_FILL });
  mergeRow(
    ws,
    row,
    COL_E,
    COL_N,
    "% of value chain partners (by value of business done with such partners) that were assessed",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );
  row += 1;

  VALUE_CHAIN_ROWS.forEach(([label, key]) => {
    setCell(ws, row, COL_D, label, { align: "left" });
    if (key === "other") {
      mergeRow(ws, row, COL_E, COL_N, "Show Detail", {
        align: "center",
        link: `#'${otherSheetName}'!D3`,
      });
    } else {
      mergeRow(ws, row, COL_E, COL_N, formatPercent(leadership?.[key]), { align: "center" });
    }
    row += 1;
  });

  return row;
}

export function buildPrinciple5Sheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet("PRINCIPLE 5", { views: [{ showGridLines: true }] });
  setPrinciple5ColumnWidths(ws);

  const principle = sectionC?.principle5 || {};
  const essential = principle?.essentialIndicators || {};
  const leadership = principle?.leadershipIndicator || {};
  const { current: fyCurrent, previous: fyPrevious } = getFyLabels(reportingYear);

  let row = 3;
  row = addSectionHeader(ws, row, `PRINCIPLE 5: ${PRINCIPLE_TITLE}`);
  row = addSectionHeader(ws, row, "Essential Indicators", SUBHEADER_FILL);

  row = addQuestionRow(
    ws,
    row,
    "1. Employees and workers who have been provided training on human rights issues and policy(ies) of the entity, in the following format:",
    "",
    { fullWidth: true }
  );

  row = addTrainingBlock(
    ws,
    row,
    essential?.humanRightsTraining?.employee,
    "Employees",
    ["Permanent", "Other than permanent", "Total Employees"],
    ["permanentEmployees", "otherThanPermanent", "total"],
    fyCurrent,
    fyPrevious
  );

  row = addTrainingBlock(
    ws,
    row,
    essential?.humanRightsTraining?.workers,
    "Workers",
    ["Permanent", "Other than permanent", "Total Workers"],
    ["permanentEmployees", "otherThanPermanent", "total"],
    fyCurrent,
    fyPrevious
  );

  row = addQuestionRow(
    ws,
    row,
    "2. Details of minimum wages paid to employees and workers, in the following format:",
    "",
    { fullWidth: true }
  );

  row = addMinimumWagesBlock(ws, row, essential?.minimumWages, "permanentEmployees", "Employees - Permanent", fyCurrent, fyPrevious);
  row = addMinimumWagesBlock(ws, row, essential?.minimumWages, "otherThanPermanentEmployees", "Employees - Other than Permanent", fyCurrent, fyPrevious);
  row = addMinimumWagesBlock(ws, row, essential?.minimumWages, "permanentWorkers", "Workers - Permanent", fyCurrent, fyPrevious);
  row = addMinimumWagesBlock(ws, row, essential?.minimumWages, "otherThanPermanentWorkers", "Workers - Other than Permanent", fyCurrent, fyPrevious);

  row = addQuestionRow(
    ws,
    row,
    "3. Details of remuneration/salary/wages, in the following format:",
    "",
    { fullWidth: true }
  );
  row = addQuestionRow(ws, row, "a. Median remuneration / wages:", "", { fullWidth: true, bold: true });

  mergeRow(ws, row, COL_D, COL_D, "Category", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_E, COL_F, "Male", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_G, COL_H, "Female", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  row += 1;

  setCell(ws, row, COL_D, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, row, COL_E, "Number", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_F, "Median remuneration/ salary/ wages of respective category", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_G, "Number", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, row, COL_H, "Median remuneration/ salary/ wages of respective category", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  row += 1;

  const median = essential?.remunerationDetails?.medianRemuneration || {};
  MEDIAN_ROWS.forEach(([label, key]) => {
    const item = median?.[key] || {};
    setCell(ws, row, COL_D, label, { align: "left" });
    setCell(ws, row, COL_E, formatNumber(item?.numberofMale ?? item?.numberofmale), { align: "center" });
    setCell(ws, row, COL_F, formatNumber(item?.medianRenumerationMale ?? item?.maleWages), { align: "center" });
    setCell(ws, row, COL_G, formatNumber(item?.numberofFemale ?? item?.numberofFemale), { align: "center" });
    setCell(ws, row, COL_H, formatNumber(item?.medianRenumerationFemale ?? item?.femaleWages), { align: "center" });
    row += 1;
  });

  row = addQuestionRow(ws, row, "b. Gross wages paid to females:", "", { fullWidth: true, bold: true });

  mergeRow(ws, row, COL_D, COL_D, "", { fill: TABLE_HEADER_FILL });
  mergeRow(ws, row, COL_E, COL_G, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_H, COL_J, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  row += 1;

  const femalePct = essential?.remunerationDetails?.femalePercentage || {};
  setCell(
    ws,
    row,
    COL_D,
    "Gross wages paid to females (Gross wages paid to females as % of total wages)",
    { align: "left", vertical: "top" }
  );
  mergeRow(ws, row, COL_E, COL_G, formatPercent(femalePct?.currentFinancialYear), {
    align: "center",
    fill: CALC_FILL,
  });
  mergeRow(ws, row, COL_H, COL_J, formatPercent(femalePct?.previousFinancialYear), {
    align: "center",
    fill: CALC_FILL,
  });
  row += 1;

  row = addShortAnswerRow(
    ws,
    row,
    "4. Do you have a focal point (Individual/ Committee) responsible for addressing human rights impacts or issues caused or contributed to by the business?",
    toYesNo(essential?.humanRightsFocalPoint?.status)
  );

  row = addTextAnswerRow(
    ws,
    row,
    "5. Describe the internal mechanisms in place to redress grievances related to human rights issues.",
    essential?.internalMechanismsHumanRightsGrievances
  );

  row = addQuestionRow(
    ws,
    row,
    "6. Number of Complaints on the following made by employees and workers:",
    "",
    { fullWidth: true }
  );
  row = addComplaintsTable(ws, row, essential?.complaintsFiled, fyCurrent, fyPrevious);

  row = addQuestionRow(
    ws,
    row,
    "7. Complaints filed under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013, in the following format:",
    "",
    { fullWidth: true }
  );
  row = addPoshTable(ws, row, essential?.complaintsFiledUnderSexualHarassemnt, fyCurrent, fyPrevious);

  row = addTextAnswerRow(
    ws,
    row,
    "8. Mechanisms to prevent adverse consequences to the complainant in discrimination and harassment cases.",
    essential?.mechanismsToPreventAdverseConsequences
  );

  row = addShortAnswerRow(
    ws,
    row,
    "9. Do human rights requirements form part of your business agreements and contracts? (Yes/No/NA)",
    toYesNoNa(essential?.humanRightsRequirementsInAgreements?.action)
  );

  row = addQuestionRow(ws, row, "10. Assessments for the year:", "", { fullWidth: true });
  row = addAssessmentTable(ws, row, essential?.assessmentsForYear, OTHER_ASSESSMENTS_SHEET);

  row = addTextAnswerRow(
    ws,
    row,
    "11. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 10 above.",
    essential?.correctiveActionsForAssessments
  );

  row = addSectionHeader(ws, row, "Leadership Indicators", SUBHEADER_FILL);

  row = addTextAnswerRow(
    ws,
    row,
    "1. Details of a business process being modified / introduced as a result of addressing human rights grievances/complaints.",
    leadership?.businessProcessBeingModified
  );

  row = addTextAnswerRow(
    ws,
    row,
    "2. Details of the scope and coverage of any Human rights due-diligence conducted",
    leadership?.humanRightsDueDiligence
  );

  row = addShortAnswerRow(
    ws,
    row,
    "3. Is the premise/office of the entity accessible to differently abled visitors, as per the requirements of the Rights of Persons with Disabilities Act, 2016?",
    safeText(leadership?.accessibilityToDifferentlyAbled)
  );

  row = addQuestionRow(ws, row, "4. Details on assessment of value chain partners:", "", { fullWidth: true });
  row = addValueChainTable(ws, row, leadership, OTHER_VALUE_CHAIN_SHEET);

  row = addTextAnswerRow(
    ws,
    row,
    "5. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 4 above.",
    leadership?.correctiveActionTakenUnderway
  );

  return ws;
}
